import React, { useState, useEffect, useRef } from 'react';
import './Team.css';

// Import SVGs as components
import { ReactComponent as Avatar1 } from '../assets/avatar1.svg';
import { ReactComponent as Avatar2 } from '../assets/avatar2.svg';
import { ReactComponent as Avatar3 } from '../assets/avatar3.svg';
import { ReactComponent as Likith } from '../assets/likith.svg';
import { ReactComponent as Soundarya } from '../assets/soundarya.svg';
import { ReactComponent as Dheeraj } from '../assets/dheeraj.svg';
import { ReactComponent as Manaswini } from '../assets/manaswini.svg';
import { ReactComponent as Yathiraj } from '../assets/yathiraj.svg';
import { ReactComponent as Anirudh } from '../assets/anirudh.svg';
import { ReactComponent as Ishani } from '../assets/ishani.svg';
import { ReactComponent as Bhuvana } from '../assets/bhuvana.svg';
import { ReactComponent as Nandish } from '../assets/nandish.svg';
import { ReactComponent as Charan } from '../assets/charan.svg';







import { ReactComponent as Abhishek } from '../assets/abhishek.svg';

// Import new decorative SVGs
import { ReactComponent as StarIcon } from '../assets/star.svg';
import { ReactComponent as SunIcon } from '../assets/sun.svg';
import { ReactComponent as PlusIcon } from '../assets/plus.svg';
import { FaRegLightbulb, FaMobileAlt, FaDesktop } from "react-icons/fa";
import { HiOutlineChip } from "react-icons/hi";

const Team = () => {
    const [activeTab, setActiveTab] = useState('Leadership & Planning');
    const [isHovered, setIsHovered] = useState(false);
    const intervalRef = useRef(null);

    const tabs = [
        { name: 'Leadership & Planning', icon: <FaRegLightbulb /> },
        { name: 'Mobile App Development', icon: <FaMobileAlt /> },
        { name: 'Web Application Development', icon: <FaDesktop /> },
        { name: 'Embedded Electronics & IoT', icon: <HiOutlineChip /> },
    ];

    const teamMembers = {
        'Leadership & Planning': [
            { name: 'Likith Kumar', role: 'Leadership', ImgComponent: Likith },
            { name: 'Abhishek Bhat', role: 'Tech Lead', ImgComponent: Abhishek },
        ],
        'Mobile App Development': [
            {  name: 'Abhishek Bhat', role: 'App Developer', ImgComponent: Abhishek ,
                name: 'Soundarya BN', role: 'App Developer', ImgComponent: Soundarya },
            { name: 'Manaswini JM', role: 'App Developer', ImgComponent: Manaswini },
            { name: 'Dheeraj Shetty', role: 'App Developer', ImgComponent: Dheeraj },
        ],
        'Web Application Development': [
            { name: 'Yathiraj U', role: 'Web Developer', ImgComponent: Yathiraj },
            { name: 'Anirudh Ballal', role: 'Web Developer', ImgComponent: Anirudh },
            { name: 'Charan', role: 'Web Developer', ImgComponent: Charan },
            { name: 'Ishani KV', role: 'UI/UX Designer', ImgComponent: Ishani },
        ],
        'Embedded Electronics & IoT': [
            { name: 'Likith Kumar', role: 'Embedded Software Developer', ImgComponent: Likith },
            { name: 'Nandish Kumar', role: 'Embedded Software Developer', ImgComponent: Nandish },
            { name: 'Bhuvana DT', role: 'Embedded Software Developer', ImgComponent: Bhuvana },
        ],
    };

    // Auto-slide logic
    useEffect(() => {
        if (!isHovered) {
            intervalRef.current = setInterval(() => {
                setActiveTab(prev => {
                    const currentIndex = tabs.findIndex(tab => tab.name === prev);
                    const nextIndex = (currentIndex + 1) % tabs.length;
                    return tabs[nextIndex].name;
                });
            }, 2000);
        }

        return () => clearInterval(intervalRef.current);
    }, [isHovered]);

    // Handle hover start
    const handleMouseEnter = () => {
        setIsHovered(true);
        clearInterval(intervalRef.current);
    };

    // Handle hover end
    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    return (
        <div className="team-container">
            <div className="team-header">
                <div className="avatars">
                    <Avatar1 />
                    <Avatar2 />
                    <Avatar3 />
                </div>
                <div className="title">
                    <p>Our <br /> Powerful Team</p>
                </div>
                <div className="decor-icons">
                    <PlusIcon className="decor-svg" />
                    <StarIcon className="decor-svg" />
                    <SunIcon className="decor-svg" />
                </div>
            </div>

            <div className="tabs">
                {tabs.map((tab) => (
                    <button
                        key={tab.name}
                        className={activeTab === tab.name ? 'tab active' : 'tab'}
                        onClick={() => setActiveTab(tab.name)}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                    >
                        <span className="icon">{tab.icon}</span>
                        {tab.name}
                    </button>
                ))}
            </div>

<div className="members" key={activeTab}>
  {teamMembers[activeTab].map((member, index) => (
    <div key={index} className="member-card">
      <member.ImgComponent />
      <h3>{member.name}</h3>
      <p>{member.role}</p>
    </div>
  ))}
</div>

        </div>
    );
};

export default Team;
